import { api } from 'boot/axios.js'
/**
 * @typedef {('DRAFT'|'PUBLISHED')} ChangelogStatus
 */

/**
 * @typedef {{
 *   id?: ?string,
 *   description?: ?string,
 *   title?: ?string,
 *   versionDate?: ?string,
 *   status?: !ChangelogStatus,
 *   content?: ?string,
 *   publicationDate?: ?string
 * }} Changelog
 */

/**
 * @typedef {{
 *  searchQuery?: ?string,
 *  status?: ?ChangelogStatus
 *  }} ChangelogFilters
 */

/**
 * @typedef {{
 *  page: !number,
 *  pageSize: !number
 *  }} Pagination
 */

/**
 * @param id
 * @returns {Promise<{data: Changelog}>}
 */
export function fetchChangelog(id) {
  return api.get(`/changelogs/${id}`)
}

/**
 * @param {Pagination} pagination
 * @param {ChangelogFilters} filters
 * @returns {Promise<{
 *   data: {
 *     data: Changelog[],
 *     totalItems: !number,
 *     lastUnreadId: ?number,
 *   }
 * }>}
 */
export function listChangelogs(pagination, filters = {}) {
  const params = {
    page: pagination.page,
    pageSize: pagination.pageSize,
    ...filters || {}
  }
  return api.get('/changelogs', { params })
}

/**
 * @param {Changelog} data
 * @returns {Promise<{data: Changelog}>}
 */
export function createChangelog(data) {
  return api.post('/changelogs', data)
}

/**
 * @param {string} id
 * @param {Changelog} data
 * @returns {Promise<{data: Changelog}>}
 */
export function updateChangelog(id, data) {
  return api.put(`/changelogs/${id}`, data)
}

/**
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
export function deleteChangelog(id) {
  return api.delete(`/changelogs/${id}`)
}

/**
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
export function publishChangelog(id) {
  return api.post(`/changelogs/${id}/publish`)
}

/**
 * @returns {Promise<{data: Changelog}|null>}
 */
export function getLastUnreadChangeLog() {
  return api.get('/changelogs/changelog/unread')
}

/**
 * @returns {Promise<AxiosResponse<any>>}
 */
export function markLastUnreadChangeLogAsRead() {
  return api.put('/changelogs/changelog/mark-as-read')
}
